<template>
  <b-modal
    id="map-modal"
    ref="map-modal"
    centered
    hide-header
    modal-class="coop-modal"
  >
    <button
      type="button"
      class="modal-close-button"
      @click.prevent="closeModal"
    >
      <img src="~assets/images/close-button.svg">
    </button>
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="map">
            <img src="/images/map.svg">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col order-1">
          <button
            type="button"
            class="button"
            @click="openGoogleMap"
          >
            GOOGLE MAP
          </button>
        </div>
        <div class="col order-first order-lg-1">
          <div class="map-legend">
            <img src="/images/map-legend.svg">
          </div>
        </div>
      </div>
    </div>
    <template slot="modal-footer">
      <span />
    </template>
  </b-modal>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    openModal () {
      if (this.$refs['map-modal']) {
        this.$refs['map-modal'].show()
      }
    },
    closeModal () {
      if (this.$refs['map-modal']) {
        this.$refs['map-modal'].hide()
      }
    },
    openGoogleMap () {
      window.open('https://www.google.com/maps/dir//%E0%B8%8B%E0%B8%B5+%E0%B8%AD%E0%B8%B2%E0%B9%80%E0%B8%8B%E0%B8%B5%E0%B8%A2%E0%B8%99+%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B8%A2%E0%B9%88%E0%B8%B2%E0%B8%99+%E0%B9%82%E0%B8%84-%E0%B8%AD%E0%B8%AD%E0%B8%9B+1583+%E0%B8%96%E0%B8%99%E0%B8%99%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%A3%E0%B8%B2%E0%B8%A1%E0%B8%97%E0%B8%B5%E0%B9%88+%E0%B9%94+%E0%B9%81%E0%B8%82%E0%B8%A7%E0%B8%87%E0%B8%A7%E0%B8%B1%E0%B8%87%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B9%88+%E0%B9%80%E0%B8%82%E0%B8%95%E0%B8%9B%E0%B8%97%E0%B8%B8%E0%B8%A1%E0%B8%A7%E0%B8%B1%E0%B8%99+%E0%B8%81%E0%B8%A3%E0%B8%B8%E0%B8%87%E0%B9%80%E0%B8%97%E0%B8%9E%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%99%E0%B8%84%E0%B8%A3+10330/@13.7337659,100.4581452,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x30e299baa7596e09:0x87b1b4d86f30f73f!2m2!1d100.5281857!2d13.7337758?entry=ttu', '_blank')
    }
  }
}
</script>
